import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-alerta',
    templateUrl: './dialog-alerta.component.html',
    styleUrl: './dialog-alerta.component.css',
    standalone: false
})
export class DialogAlertaComponent {

  constructor(
    public dialogRef: MatDialogRef<DialogAlertaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string,
  ) {}

}
